import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import React from "react";
import AugerStateDTO from "src/models/AugerStateDTO";
import CurrentSensorStateDTO from "src/models/CurrentSensorStateDTO";
import SensorReading from "./SensorReading";

interface AugerStateViewProps {
    augers: AugerStateDTO[] | null | undefined;
    isMachineOn: boolean | null | undefined;
    machineCurrent: CurrentSensorStateDTO | null | undefined;
}

type AugerWithSensor = AugerStateDTO & {
    currentSensorState?: CurrentSensorStateDTO | null;
};

const formatAmps = (mA: number | null | undefined): string => {
    if (mA == null) return '--';
    return `${(mA / 1000).toFixed(2)} A`;
};

const OnOff: React.FC<{ value: boolean | null | undefined }> = ({ value }) => {
    if (value == null) return <CloseCircleOutlined style={{ color: '#aaa' }} />;
    return value
        ? <CheckCircleOutlined style={{ color: '#52c41a' }} />
        : <CloseCircleOutlined style={{ color: '#ff4d4f' }} />;
};

const AugerStateView: React.FC<AugerStateViewProps> = ({ augers, isMachineOn, machineCurrent }) => {
    const rows = (augers ?? []) as AugerWithSensor[];

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <table style={{ borderCollapse: 'collapse', width: '100%', color: '#000' }}>
                <thead>
                    <tr>
                        <th style={{ textAlign: 'left', fontWeight: 500, paddingBottom: 4 }}>Device</th>
                        <th style={{ textAlign: 'center', fontWeight: 500, paddingBottom: 4 }}>On/Off</th>
                        <th style={{ textAlign: 'right', fontWeight: 500, paddingBottom: 4 }}>Current</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((aug) => {
                        const sensor = aug.currentSensorState;
                        const milliAmps = sensor?.currentMilliAmps ?? aug.currentMilliAmps;
                        return (
                            <tr key={aug.number} style={{ verticalAlign: 'middle' }}>
                                <td style={{ textAlign: 'left', padding: '4px 0' }}>Auger {aug.number}</td>
                                <td style={{ textAlign: 'center' }}><OnOff value={aug.isOn} /></td>
                                <td style={{ textAlign: 'right', fontFamily: 'monospace' }}>
                                    <SensorReading
                                        value={formatAmps(milliAmps)}
                                        code={sensor?.statusCodeRaw}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                    <tr style={{ verticalAlign: 'middle', borderTop: '1px solid #d9d9d9' }}>
                        <td style={{ textAlign: 'left', padding: '4px 0' }}>Machine</td>
                        <td style={{ textAlign: 'center' }}><OnOff value={isMachineOn} /></td>
                        <td style={{ textAlign: 'right', fontFamily: 'monospace' }}>
                            <SensorReading
                                value={formatAmps(machineCurrent?.currentMilliAmps)}
                                code={machineCurrent?.statusCodeRaw}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default AugerStateView;
